var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{staticClass:"cbaas-empty"},[_c('template',{slot:"image"},[_c('img-empty')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }